/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Description_HeadingInputs */

const en_shortcut_keys_description_heading = /** @type {(inputs: Shortcut_Keys_Description_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const fr_shortcut_keys_description_heading = /** @type {(inputs: Shortcut_Keys_Description_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const de_shortcut_keys_description_heading = /** @type {(inputs: Shortcut_Keys_Description_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung`)
};

const it_shortcut_keys_description_heading = /** @type {(inputs: Shortcut_Keys_Description_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione`)
};

const ru_shortcut_keys_description_heading = /** @type {(inputs: Shortcut_Keys_Description_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описание`)
};

const es_shortcut_keys_description_heading = /** @type {(inputs: Shortcut_Keys_Description_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción`)
};

const zh_cn2_shortcut_keys_description_heading = /** @type {(inputs: Shortcut_Keys_Description_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描述`)
};

const ja_shortcut_keys_description_heading = /** @type {(inputs: Shortcut_Keys_Description_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`説明`)
};

const hi_shortcut_keys_description_heading = /** @type {(inputs: Shortcut_Keys_Description_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विवरण`)
};

const pt_pt2_shortcut_keys_description_heading = /** @type {(inputs: Shortcut_Keys_Description_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Shortcut_Keys_Description_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_description_heading = /** @type {((inputs?: Shortcut_Keys_Description_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Description_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_description_heading(inputs)
	if (locale === "de") return de_shortcut_keys_description_heading(inputs)
	if (locale === "it") return it_shortcut_keys_description_heading(inputs)
	if (locale === "ru") return ru_shortcut_keys_description_heading(inputs)
	if (locale === "es") return es_shortcut_keys_description_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_description_heading(inputs)
	if (locale === "ja") return ja_shortcut_keys_description_heading(inputs)
	if (locale === "hi") return hi_shortcut_keys_description_heading(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_description_heading(inputs)
	return en_shortcut_keys_description_heading(inputs)
});